import { Navigate, useLocation } from "react-router-dom";

import { useDepartmentRoute } from "@/hooks/common/use-department-route";
import { RoutePathEnum } from "@/routes/paths";
import { useUserStore } from "@/stores/use-user-store";
import { getUserInitialDepartmentRoute } from "@/utils/department-routes";
import { userHasDepartment } from "@/utils/user-positions";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isLoading, activeUser } = useUserStore();
  const { isValid, department } = useDepartmentRoute();

  // 1. Primeiro verificar loading
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
      </div>
    );
  }

  // 2. Verificar autenticação (se não estiver autenticado, redirecionar para login)
  if (!activeUser) {
    return <Navigate to={RoutePathEnum.LOGIN} state={{ from: location }} replace />;
  }

  const initialDepartmentRoute = getUserInitialDepartmentRoute(activeUser);

  if (!initialDepartmentRoute) {
    return <Navigate to={RoutePathEnum.LOGIN} replace />;
  }

  // 3. Se o slug de department é inválido, redirecionar para o primeiro department do usuário
  if (!isValid) {
    return <Navigate to={initialDepartmentRoute} replace />;
  }

  // 4. Validar se o usuário possui posição no department da URL
  if (!userHasDepartment(activeUser, department)) {
    return <Navigate to={initialDepartmentRoute} replace />;
  }

  return <>{children}</>;
}
